import { useState } from 'react';
import Link from 'next/link';
import { CreatorLink, Location } from 'lib/types';
import { useRouter } from 'next/router';

interface Props {
  location?: Partial<Location>;
  role: string;
  /** TODO: Delete locationName since we now send in `location` above */
  locationName: string;
  roleName: string;
  moreRoles: CreatorLink[];
  moreLocations: CreatorLink[];
}

export const CreatorLinksFooter = ({
  location, role, locationName, roleName, moreRoles, moreLocations,
}: Props) => {
  const router = useRouter();
  const linksToShow = 6;
  const [showMoreLocations, setShowMoreLocations] = useState(moreLocations.length > linksToShow);
  const [showMoreRoles, setShowMoreRoles] = useState(moreRoles.length > linksToShow);
  if (!location && !role) {
    return null;
  }

  const currentGeoQuery = router?.query?.geo || '';

  const renderMoreLocations = () => {
    if (moreLocations.length < 1) {
      return null;
    }
    return (
      <div className="pb-6">
        <h3 className="font-bold mb-4">
          {`${roleName} by Location`}
        </h3>
        {moreLocations.slice(0, showMoreLocations ? linksToShow : 100).map((r) => (
          <div key={r.locationName} className="mb-2">
            <Link
              href={{ pathname: '/creators', query: r.searchCriteria }}
              className="hover:underline"
            >

              {`${r.roleName || roleName} in ${r.locationName}`}
            </Link>
          </div>
        ))}
        <button type="button" className="font-bold text-orange hover:underline" onClick={() => setShowMoreLocations((p) => !p)}>
          Show
          {' '}
          {showMoreLocations ? 'more' : 'less'}
        </button>
      </div>
    );
  };

  return (
    <div className="bg-hintgray p-4 text-center sm:text-left">
      <div className="p-4 max-w-screen-xl m-auto flex flex-wrap justify-around">
        {renderMoreLocations()}
        <div>
          <h3 className="font-bold mb-4">
            You Might Also Like
          </h3>
          {!!currentGeoQuery && location?.name && (
            <div key={`all-${locationName}`} className="mb-2">
              <Link
                href={{ pathname: '/creators', query: { geo: currentGeoQuery } }}
                className="hover:underline"
              >

                {`All creators in ${location.name}`}
              </Link>
            </div>
          )}
          {moreRoles.slice(0, showMoreRoles ? linksToShow : 100).map((r) => (
            <div key={`${r.roleName}${r.locationName}`} className="mb-2">
              <Link
                href={{ pathname: '/creators', query: r.searchCriteria }}
                className="hover:underline"
              >

                {`${r.roleName} in ${r.locationName || locationName}`}
              </Link>
            </div>
          ))}
          <button type="button" className="font-bold text-orange hover:underline" onClick={() => setShowMoreRoles((p) => !p)}>
            Show
            {' '}
            {showMoreRoles ? 'more' : 'less'}
          </button>
        </div>
      </div>
    </div>
  );
};
